import { ErrorPageComponent } from './pages/error-page/error-page.component';
import { WelcomeComponent } from './pages/welcome/welcome.component';
import { PageNotFoundComponent } from './pages/page-not-found/page-not-found.component';
import { FinalComponent } from './pages/final/final.component';
import { ItemApprovalComponent } from './pages/item-approval/item-approval.component';
import { NgModule } from '@angular/core';
import {
  Routes,
  RouterModule,
  Router,
  NavigationEnd,
  ActivatedRoute
} from '@angular/router';
import { filter } from 'rxjs/operators';

const routes: Routes = [
  {
    path: 'welcome',
    component: WelcomeComponent,
    children: [
      {
        path: 'review',
        component: ItemApprovalComponent,
        data: { title: 'Item Review' }
      },
      {
        path: 'final',
        component: FinalComponent,
        data: { title: 'Confirmation' }
      }
    ]
  },
  {
    path: 'error',
    component: ErrorPageComponent,
    data: { title: 'Error', text: 'There was an issue accessing your order' }
  },
  {
    path: '**',
    component: PageNotFoundComponent
  }
];

@NgModule({
  imports: [RouterModule.forRoot(routes, { enableTracing: false })],
  exports: [RouterModule]
})
export class AppRoutingModule {
  constructor(private router: Router) {
    router.events
      .pipe(filter(event => event instanceof NavigationEnd))
      .subscribe((route: ActivatedRoute) => {
        window.scrollTo(0, 0);
      });
  }
}
